import { MdArrowBack } from 'react-icons/md';

import FadeIn from 'legacy/common/components/transition/FadeIn';
import Loader from 'legacy/common/components/layout/Loader';
import { StepProps, StepsId } from '../../types';
import EventInfo from '../../../EventInfo';
import { useMultiTierCheckout } from '../../context';
import Summary from './components/Summary';
import PaymentMethod from '../../../PaymentMethod';
import useAuthenticationStatus from 'legacy/common/hooks/useAuthenticationStatus';
import ConfirmButton from './components/ConfirmButton';
import PaymentOptions from '../PaymentOptions';

import styles from '../../../Checkout.module.scss';

const ConfirmTransactionStep = ({ goToStep }: StepProps) => {
  const { isAuthenticated } = useAuthenticationStatus();
  const {
    data: { event, checkoutSession, paymentMethod },
    addNewCardAndSave
  } = useMultiTierCheckout();
  const isHandlingNewlyAuthenticatedUser = false;

  const goToTicketsSelection = () => {
    goToStep(StepsId.TicketsSelectionStep);
  };

  const goToCardSelection = () => {
    goToStep(StepsId.SelectCardStep);
  };

  const isLoading =
    checkoutSession.isLoadingCheckout || isHandlingNewlyAuthenticatedUser;

  return (
    <Loader isOverlay isLoading={isLoading}>
      <div className={styles.wrapper}>
        <div className="relative">
          <MdArrowBack
            size="26px"
            className="cursor-pointer absolute -top-6 left-3 text-gray-500"
            onClick={goToTicketsSelection}
          />
        </div>
        <div className="px-6 overflow-y-auto">
          <FadeIn>
            <div className="px-5">
              <EventInfo event={event} />
              <div className="pb-16">
                <Summary goToTicketsSelection={goToTicketsSelection} />
                {isAuthenticated() &&
                  checkoutSession.checkoutSession?.total > 0 && (
                    <div className="flex flex-col gap-4 pb-4">
                      {checkoutSession.isNewCheckoutEnabled ? (
                        <PaymentOptions
                          addCard={addNewCardAndSave}
                          cards={paymentMethod.cards}
                          selectedCardId={paymentMethod.selectedCard.value}
                          purchaseCurrency={
                            checkoutSession.checkoutSession.currency
                          }
                          loading={checkoutSession.isConfirmingCheckout}
                          navigateToSelectPaymentMethod={goToCardSelection}
                        />
                      ) : (
                        <PaymentMethod
                          addCard={addNewCardAndSave}
                          cards={paymentMethod.cards}
                          selectedCardId={paymentMethod.selectedCard.value}
                          purchaseCurrency={
                            checkoutSession.checkoutSession.currency
                          }
                          loading={checkoutSession.isConfirmingCheckout}
                          navigateToSelectPaymentMethod={goToCardSelection}
                        />
                      )}
                    </div>
                  )}
              </div>
            </div>
          </FadeIn>
        </div>
        <ConfirmButton goToStep={goToStep} />
      </div>
    </Loader>
  );
};

export default ConfirmTransactionStep;
